import { render, staticRenderFns } from "./PartnerSetting.vue?vue&type=template&id=09c06539"
import script from "./PartnerSetting.vue?vue&type=script&lang=js"
export * from "./PartnerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports